import { Box } from "@mui/material";
import styled from "styled-components";

export const SettingsStyled = styled(Box)`
  .header {
    h2 {
      margin-bottom: 16px;
    }
  }

  .settings-card-wrapper {
    display: flex;
    flex-direction: column;
    gap: 24px;
    .card-wrapper {
      background-color: #fff;
      padding: 24px;
      border-radius: 20px;
      row-gap: 24px;

      .content-wrapper {
        display: flex;
        flex-direction: column;
        row-gap: 16px;
        @media (max-width: 768px) {
          row-gap: 24px;
        }

        .fields-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 24px;
          @media (max-width: 1024px) {
            grid-template-columns: 1fr 1fr;
          }

          @media (max-width: 768px) {
            grid-template-columns: 1fr;
            row-gap: 24px;
          }
        }
      }
    }
  }

  .button-wrapper {
    align-self: flex-end;
    margin-top: 8px;
    @media (max-width: 768px) {
      align-self: center;
      width: 100%;
    }
  }
`;
